import './DecorativeDivider.css';

interface DecorativeDividerProps {
  variant?: 'default' | 'bottom';
}

export default function DecorativeDivider({ variant = 'default' }: DecorativeDividerProps) {
  return (
    <div
      className={`decorative-divider ${variant === 'bottom' ? 'decorative-divider-bottom' : ''}`}
    >
      {variant === 'default' && <div className="monitor-shadow"></div>}
      {variant === 'default' && <div className="divider-bar divider-bar-3"></div>}
      <div className="divider-bar divider-bar-2"></div>
      <div className="divider-bar divider-bar-1"></div>
    </div>
  );
}
